import Vue from 'vue'
import VueRouter from 'vue-router'
import userService from '../services/user.service'
Vue.use(VueRouter)

const routes = [
 {
    path: '/mapa',
    name: 'mapa',
    component: () => import('../views/map.vue')
  },


  {
    path: '/',
    name: 'inicio',
    component: () => import('../views/Home')
  },

  {
    path: '/aviso-de-privacidad',
    name: 'aviso',
    component: () => import('../views/Aviso.vue')
  },

  {
    path: '*',
    name: '404',
    component: () => import('../views/Error404')
  },


]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach(async (to, from, next) => {
  
  /*
  if (to.path === '/mapa') {
    const result = userService.isLoggedIn()
    if(!result.log){
      next('/')
      return
    }
    next()
    return 
  }
  */

  if (to.path === from.path) {
    window.scrollTo(0, 0);
  }
  next();


  window.scrollTo({ top: 0, behavior: "instant" });
  next();
});




export default router

